export const SPENDS_PRICE = 'spends_price';
export const SPENDS_PERCENTS = 'spends_percents';
export const SUBSCRIPTION = 'subscription';
